module.exports = function flexible(set_dom, p_width, p_height) {
    // 返回文档的root元素
    var docEl = document.documentElement
    // 获取设备的dpr，即当前设置下物理像素与虚拟像素的比值
    var dpr = window.devicePixelRatio || 1

    var browser = {
        isMobile() {
            var u = navigator.userAgent
            return !!u.match(/AppleWebKit.*Mobile.*/)
        },
        isIPad() {
            var u = navigator.userAgent
            return !!u.match(/iPad.*/)
        }
    }

    function get_type(width, height, p_width, p_height) {
        var now_pro = width / height
        var proportion = p_width / p_height

        if (now_pro > proportion) {
            var max_bili = p_height / height
            return { type: 'h', height: height, width: p_width / max_bili }
        }
        var max_bili = p_width / width
        return { type: 'w', height: height, width: width }
    }

    function setRemUnit() {
        var width = window.innerWidth || docEl.clientWidth
        var height = window.innerHeight || docEl.clientHeight
        var basePx = width

        var h_or_w = get_type(width, height, p_width, p_height)


        set_dom && set_dom.forEach(dom => {
            if (!dom) {
                return
            }
            dom.style.height = h_or_w.height + "px"
            dom.style.width = h_or_w.width + "px"
        })

        var rem = h_or_w.width * 100 / p_width


        docEl.style.fontSize = rem + 'px'

        var html_style = window.getComputedStyle(document.getElementsByTagName("html")[0])

        if (html_style.fontSize && browser.isMobile() && !browser.isIPad()) {
            var size = html_style.fontSize.split('p')[0]
            var n_size = (basePx / p_width)
            // if (size * 1.2 < 100 * n_size) {
            //     // 如果当前html的font-size 的1.2倍仍然小于 之前想设置的值，就说明是问题机型，给之前想附的值乘1.25倍，这样他会被系统再次除1.25得到的才是我们想附的值
            //     rem = 125 * n_size;
            //     docEl.style.fontSize = rem + 'px'
            // }
        }
        if (navigator.userAgent.includes('Firefox') && navigator.userAgent.includes('Mobile')) {
            docEl.style.fontSize = rem * 0.9 + 'px'
        }
        return rem
    }


    var size = setRemUnit()
    // 当我们页面尺寸大小发生变化的时候，要重新设置下rem 的大小
    // window.addEventListener('resize', setRemUnit)
    setTimeout(function(){
        setRemUnit()
    },100)
    // pageshow 是我们重新加载页面触发的事件
    window.addEventListener('pageshow', function(e) {
        // e.persisted 返回的是true 就是说如果这个页面是从缓存取过来的页面，也需要从新计算一下rem 的大小
        e.persisted && setRemUnit()
    })

    // 检测0.5px的支持，支持则root元素的class中有hairlines
    if (dpr >= 2) {
        var fakeBody = document.createElement('body')
        var testElement = document.createElement('div')
        testElement.style.border = '.5px solid transparent'
        fakeBody.appendChild(testElement)
        docEl.appendChild(fakeBody)
        if (testElement.offsetHeight === 1) {
            docEl.classList.add('hairlines')
        }
        docEl.removeChild(fakeBody)
    }
    return size

}